import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table, TableBody, TableCircularProgressBackdrop, TableContainer, TableHead } from '@/core/ui';
import { forwardRef } from 'react';
import { styled } from '@mui/material';
import { TableBodyEmpty } from '../TableBodyEmpty';
import { SelectableTableRow } from './SelectableTableRow.styled';
function createVirtuosoTableComponents(props) {
    const { components } = props ?? {};
    return {
        // Working simple solution of Scroller without the bug.
        // Scroller: forwardRef(({ context, ...props }, ref) => <TableContainer {...props} ref={ref} />),
        // Scroller:
        // 	components?.Scroller ??
        // 	forwardRef(({ context, ...props }, ref) => (
        // 		<TableContainer
        // 			{...props}
        // 			ref={ref}
        // 			// TODO: later.
        // 			// This is temporary bugfix (the same as below, but with not depending on state variables): when list is [] then the height of
        // 			// the TableContainer is equal to header height.
        // 			// Check if it works fine, then refactor. It doesn't work in some tables, so the fix below is still actual
        // 			// sx={{ display: 'flex', flex: 1 }}
        // 		/>
        // 	)),
        Scroller: components?.Scroller ??
            forwardRef(({ context, ...props }, ref) => {
                const { isLoading, isEmpty, isError } = context;
                // Fixes bug when empty set forces TableContainer to have height that equals to head height, therefore
                // EmptyPlaceholder is not visible.
                const sxVirtuosoBugFix = { height: isLoading || isEmpty || isError ? '60vh !important' : undefined };
                // `flex: 1` is necessary here if there are small amount of rows (1 for example)
                return _jsx(TableContainer, { ...props, ref: ref, sx: sxVirtuosoBugFix });
            }),
        Table: components?.Table ??
            forwardRef(({ context, ...props }, ref) => (_jsx(GoodsWorkflowTableStyled, { size: "medium", sideCellSpacing: 4, ...props, ref: ref }))),
        TableHead: components?.TableHead ?? forwardRef(({ context, ...props }, ref) => _jsx(TableHead, { ...props, ref: ref })),
        // // TableRow with forwardRef version.
        // TableRow:
        // 	components?.TableRow ??
        // 	forwardRef(({ context, item, ...props }, ref: Ref<HTMLTableRowElement>) => {
        // 		const { selectedItemIndex, onRowClick, onRowDoubleClick } = context;
        // 		// // Not selectable by arrow up\down or mouse click, but only selectable on Article search.
        // 		// <PackingDetailsTableRow
        // 		// 	hover
        // 		// 	{...props}
        // 		// 	// Check if ref is working ok (there was not ref here)
        // 		// 	ref={ref}
        // 		// 	selected={context.selectedItemIndex === props['data-item-index']}
        // 		// 	disabled={item.state !== StickerState.Packed}
        // 		// />
        // 		return (
        // 			<SelectableTableRow
        // 				hover
        // 				{...props}
        // 				// ref={ref}
        // 				selected={selectedItemIndex !== undefined ? selectedItemIndex === props['data-item-index'] : false}
        // 				onClick={() => {
        // 					onRowClick?.(item);
        // 				}}
        // 				onDoubleClick={() => {
        // 					onRowDoubleClick?.(item);
        // 				}}
        // 			/>
        // 		);
        // 	}),
        TableRow: components?.TableRow ??
            // forwardRef(({ context, item, ...props }, ref: Ref<HTMLTableRowElement>) => {
            (({ context, item, ...props }) => {
                const { selectedItemIndex, onRowClick, onRowDoubleClick } = context;
                // // Not selectable by arrow up\down or mouse click, but only selectable on Article search.
                // <PackingDetailsTableRow
                // 	hover
                // 	{...props}
                // 	// Check if ref is working ok (there was not ref here)
                // 	ref={ref}
                // 	selected={context.selectedItemIndex === props['data-item-index']}
                // 	disabled={item.state !== StickerState.Packed}
                // />
                return (_jsx(SelectableTableRow, { hover: true, ...props, 
                    // ref={ref}
                    selected: selectedItemIndex !== undefined ? selectedItemIndex === props['data-item-index'] : false, onClick: () => {
                        onRowClick?.(item);
                    }, onDoubleClick: () => {
                        onRowDoubleClick?.(item);
                    } }));
            }),
        TableBody: components?.TableBody ??
            forwardRef(({ children, context, ...props }, ref) => {
                const { isLoading, isFetching, isError, error, isEmpty, isWaitingForSocketConnection, columnCount } = context;
                return (_jsxs(TableBody, { relative: true, ...props, ref: ref, children: [_jsx(TableBodyEmpty, { isLoading: isLoading, isError: isError, error: error, columnCount: columnCount, isEmpty: isEmpty, isWaitingForSocketConnection: isWaitingForSocketConnection }), !isLoading && children, _jsx(TableCircularProgressBackdrop, { open: isFetching && !isLoading && !isEmpty, columnCount: columnCount })] }));
            }),
        // Do not use `EmptyPlaceholder` prop, since it is not working with loading states.
        // EmptyPlaceholder: ({ context, ...props }) => {})
    };
}
// const DefaultScroller = forwardRef<HTMLDivElement, ScrollerProps & ContextProp<unknown>>(({ context, ...props }, ref) => (
// 	<TableContainer {...props} ref={ref} />
// ));
// const DefaultTable = forwardRef<HTMLDivElement, TableProps & ContextProp<unknown>>(({ context, ...props }) => (
// 	<GoodsWorkflowTableStyled size="medium" sideCellSpacing={4} {...props} />
// ));
// const DefaultTableHead = forwardRef<HTMLDivElement, TableHeadProps & ContextProp<unknown>>(
// 	forwardRef(({ context, ...props }, ref) => <TableHead {...props} ref={ref} />)
// );
// const DefaultTableRow: TableComponents['TableRow'] = ({ context, item, ...props }) => (
// 			// Not selectable by arrow up\down or mouse click, but only selectable on Article search.
// 			<PackingDetailsTableRow
// 				hover
// 				{...props}
// 				selected={context.selectedItemIndex === props['data-item-index']}
// 				disabled={item.state !== StickerState.Packed}
// 			/>
// 		)
// TODO: check . `borderCollapse: 'separate'` adds extra strong border oh hover (not good)
// const TableStyled = styled(Table)({ borderCollapse: 'separate', userSelect: 'none' });
const GoodsWorkflowTableStyled = styled(Table)({ userSelect: 'none' });
export { createVirtuosoTableComponents };
